import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { todayIST } from "./FollowupAssign";

export const MyTasks = () => {
  const [t, setT] = useState([]);
  const load = useCallback(() => api.get("/followup-tasks/mine").then((r) => setT(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  if (!t.length) return null;
  const done = (id) => api.post(`/followup-tasks/${id}/done`).then(() => { toast.success("Marked done"); load(); }).catch((e) => toast.error(errMsg(e)));
  const today = todayIST();
  return (
    <div className="ax-panel p-4 mb-4" data-testid="my-followup-tasks">
      <div className="font-semibold text-sm mb-1">Assigned to you <span className="num text-muted-foreground">{t.length}</span></div>
      {t.map((x) => (
        <div key={x.task_id} className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2 border-t text-sm" data-testid={`my-task-${x.task_id}`}>
          <Link to={`/sales/leads/${x.lead_id}`} className="font-medium hover:text-primary">{x.company_name || x.contact_name || x.lead_id}</Link>
          <span className={`num text-xs ${x.due_date < today ? "text-rose-500" : x.due_date === today ? "text-primary" : "text-muted-foreground"}`}>{x.due_date}</span>
          <span className="text-xs text-muted-foreground flex-1 min-w-0 truncate">{x.note ? `${x.note} · ` : ""}from {x.by_name}</span>
          <button data-testid={`my-task-done-${x.task_id}`} onClick={() => done(x.task_id)} className="border text-xs px-2 py-1 hover:border-primary">Mark done</button>
        </div>))}
    </div>
  );
};
